<style lang="scss" scoped>
    @import "./establishPage.css";
	.warp_img{
		    width: 1.1rem;
		    margin-right:  .5rem;
	}
	.warp_title{
		text-align: center;
		color: #000;
	}
	.warp_color{
		color: #fff;
	}
</style>
<style lang='scss'>

    *, *::before, *::after{
        font-family: 'element-icons';

    }
    .confirmbtn{
        color: #FFFFFF !important;
        background-color: #09666e!important;
        border-color: #09666e!important;
    }
    .el-button--small:hover{
        background-color: #ffffff ;
        border-color: #dcdfe6 ;
        color: #000;
    }
	#establishPage{
			.ant-popover-message-title{
				font-size: .8rem !important;
			}
			.ant-btn-sm{
				width: 2.8rem;
				height: 1.5rem;
				span{
					font-size: .7rem !important;
				}
			}
	}
</style>
<template>
    <div id="establishPage">
        <div class="topHeader">
            <a-form-model :model="form" style="width:100%;" labelAlign="right" layout="inline">
                <a-row style="display: flex;align-items: center;">
                    <a-col  :xl="{ span: 24 }">
                        <a-row style="display: flex;">
                            <a-col :xl="{ span: 5 }" class="sous_class">
                                <a-form-model-item label="系統模塊" class="formItem">
                                    <a-select v-model="form.admintype" placeholder="請選擇系統模塊" @change="admintypeChange">
                                        <a-select-option v-for="(item) in admintypeArr" :key="item.key" :value="item.value">{{item.text}}</a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 5 }" class="sous_class">
                                <a-form-model-item label="開戶方式" class="formItem">
                                    <a-select v-model="form.khtype" placeholder="請選擇開戶方式" @change='searchEvent'>
                                        <a-select-option v-for="(item) in khtypeArr" :key="item.key" :value="item.value">{{item.text}}</a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 5 }" class="sous_class">
                                <a-form-model-item label="信息查詢" class="formItem">
                                    <a-input v-model="form.searchstr" placeholder="請輸入證券編號" :allowClear="true" @change="handleClear()"/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 6 }" class="sous_class">
                                <a-form-model-item label="提交時間" class="formItem">
                                    <a-range-picker :placeholder="['開始時間','結束時間']" v-model="form.timeDate"/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 3 }" style="display: inline-flex;align-items: center;justify-content: flex-end;" class="but_class">
                                <div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" @click="searchEvent">
                                    <img src="../../image/icon_sousuo.png" class="btnIcon"/>
                                    <span>搜索</span>
                                </div>
                                <div class="btn_cla" style="background-color:#ffa647;" @click="clearEvent">
                                    <img src="../../image/icon_chongzhi.png" class="btnIcon"/>
                                    <span>重置</span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </a-form-model>
        </div>
        <div class="bottomMain">
            <div class="tableBtnView">
                <a-button class="bottomBtn" style="background-color:#ffa647;" @click="kaihuClick()" v-if="ifQt">
                    <img src="../../image/tjkh.png" class="btnIcon"/>
                    <span>添加預約</span>
                </a-button>
                <!-- -->
                <a-button class="bottomBtn" style="background-color:#a06bf1;" @click="isopens = true" v-if="ifHt">
                    <img src="../../image/yykh.png" class="btnIcon"/>
                    <span>添加開戶</span>
                </a-button>
                <a-button class="bottomBtn" style="background-color:#ed4849;" type="dashed" @click="delClick()">
                    <img src="../../image/icon_shanchu.png" class="btnIcon"/>
                    <span>刪除記錄</span>
                </a-button>
                <a-button class="bottomBtn" style="background-color:#ffa647;" v-if='false'>
                    <img src="../../image/icon_xiazai.png" class="btnIcon"/>
                    <span>下載</span>
                </a-button>
                <a-button class="bottomBtn" style="background-color:#3bc7a1;" @click="upClick()">
                    <img src="../../image/icon_daochu.png" class="btnIcon"/>
                    <span>導出數據</span>
                </a-button>
                <a-upload name="file" :data='{token:$store.state.token,flag:"customerInformation"}' :headers='{token:$store.state.token}'
                    class="avatar-uploader" :show-upload-list="false"
                    :before-upload="beforeUpload" @change="handleChange" :action="$api.openingAccountImport" v-if="openAccountImport">
                    <a-button class="bottomBtn" style="background-color:#467fff;" >
                        <img src="../../image/daoru.png" class="btnIcon"/>
                        <span>導入數據</span>
                    </a-button>
                </a-upload>
                <div class="bottomMsView" @click="messionEvent">
                    <a-badge :count="missionnum" :numberStyle="{width:'0.8rem',height:'0.8rem',minWidth:'0.8rem',lineHeight:'0.8rem',padding:'0',fontSize:'0.5rem',top:'0.3rem'}">
                        <img :src="missionflag ? icon_renwu1 : icon_renwu" style="width:2rem;height:2rem;">
                    </a-badge>
                    <span style="font-size:0.9rem;margin-left:0.8rem;font-weight:bold;">任務</span>
                </div>
            </div>
            <a-table
                style="width:100%;"
                :columns="columns"
                :data-source="columnsData"
                :row-selection="{
                    selectedRowKeys: selectedRows,
                    onChange: onSelectChange,
                }"
                :pagination="false"
				id='fromtable'
				:customRow='rowstely'
                :bordered="true">
				<!-- :scroll="{ y: 'calc(100vh - 430px)', x: '100vw'}" -->
				<div slot='id' slot-scope='record' style="position: relative;">
					<!-- <img :src="alarm_clock" alt=""> -->
					<a-popover v-if='record.yuyuekhflag'>
					    <template slot="content">
					     <div>{{record.yuyuekhflag}}</div>
					    </template>
					    <div><img :src="alarm_clock" alt="" class='warp_img'>{{record.id}}</div>
                    </a-popover>
                    <div v-else>
                        <span v-if="httpFlag">
                            <span class="bjb_text" style="color:red;font-size:0.7rem;position: absolute; left: 0; top: 2px;" v-if="
                                record.phonenum == 6666666 ||
                                record.phonenum == 8888888 ||
                                record.phonenum == 97950637
                                "
                            >
                                Test
                            </span>
                        </span>
                        <span v-else>
                            <span class="bjb_text" style="color:red;font-size:0.7rem;position: absolute; left: 0; top: 2px;" v-if="
                                record.phonenum == 15640838820 ||
                                record.phonenum == 97950637 "
                            >
                                Test
                            </span>
                        </span>
                        <span class="bjb_text" style="color:red;font-size:0.7rem;position: absolute; left: 0; top: 2px;" v-if="record.khtype == '取消開戶'">
                            <span v-if="record.delete_flag == '1'">刪除</span>
                            <span v-else>取消</span>
                            
                        </span>
                        {{record.id}}
                    </div>
				</div>
				<div slot='khtype' slot-scope='record'>
					<div v-if='record.khtype2 != 1'>{{record.khtype}}</div>
					<a-popover v-else>
                        <template slot="content">
                            <div>{{record.yuyuetime}}</div>
                        </template>
                        <div>{{record.khtype}}</div>
                        <!-- <div v-if="record.websiteflag == 1">WEB預約開戶</div>
                        <div v-else>{{record.khtype}}</div> -->
                    </a-popover>
				</div>
                <div slot="schedule" slot-scope="record">
					<div class="tableRowView1 "  v-if='record.status == 2'>
					    <img :src=" icon_one1" alt="" class="imageC">
					    <div class="lineC" :style="(record.schedule > 1) || (record.schedule == 1 && record.status == 0) ? 'background:#467fff;' : ''">
						    <span v-if="record.status == 2" class="redX" style="opacity: 1;">x</span>
                        </div>
					    <img :src="icon_two1" alt="" class="imageC">
					    <div class="lineC" :style="(record.schedule > 2) || (record.schedule == 2 && record.status != 1) ? 'background:#6cce68;' : ''"></div>
					    <img :src=" icon_three1" alt="" class="imageC">
					    <div class="lineC" :style="(record.schedule > 3) || (record.schedule == 3 && record.status != 1) ? 'background:#f7d429;' : ''">
                            <!-- <span v-if="record.audit_status == 1" class="redX" style="opacity: 1;">x</span> -->
                        </div>
					    <img :src=" icon_four1" alt="" class="imageC">
					</div>
					<div class="tableRowView1"  v-else>
					    <img :src="record.schedule >= 1 ? icon_one : icon_one1" alt="" class="imageC">
					    <div class="lineC" :style="(record.schedule > 1) || (record.schedule == 1 && record.status == 0) ? 'background:#467fff;' : ''">
						<span v-if="record.status == 2" class="redX">x</span></div>
					    <img :src="record.schedule >= 2 ? icon_two : icon_two1" alt="" class="imageC">
					    <div class="lineC" :style="(record.schedule > 2) || (record.schedule == 2 && record.status != 1) ? 'background:#6cce68;' : ''"></div>
					    <img :src="record.schedule >= 3 ? icon_three : icon_three1" alt="" class="imageC">
					    <div class="lineC" :style="(record.schedule > 3) || (record.schedule == 3 && record.status != 1) ? 'background:#f7d429;' : ''">
                            <!-- <span v-if="record.audit_status == 1" class="redX" style="opacity: 1;">x</span> -->
                        </div>
					    <img :src="record.schedule >= 4 ? icon_four : icon_four1" alt="" class="imageC">
					</div>
                </div>
                <div slot="toolArr" slot-scope="record">
                    <div class="tableRowView2" >
                        <div class="popoverView">
							<img @click="pdfEvent(record)" :src="record.pdfShowBol ? icon_pdf1:record.status == 2?require('../../image/gr_icon1.png'):icon_pdf" class="imageC">
                        </div>
                        <div class="popoverView">
                           <!-- <a-popover :visible="record.shShowBol" placement="leftTop" :destroyTooltipOnHide="true"
                                trigger="click" @visibleChange="shEvent(record)" :overlayStyle="{width:'calc(17rem + 32px)'}"
                                :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
                                <template slot="content">
                                    <div class="tableBzView">
                                        <div v-if="record.state == 0" class="tableBzViewTitle">備註</div>
                                        <div v-if="record.state == 1" class="tableBzViewTitle2">審核拒絕</div>
                                        <div v-if="record.state == 2" class="tableBzViewTitle2">取消開戶</div>
                                        <div style="padding:0rem 0.8rem 0.3rem;width:100%;">
                                            <div class="tableBzViewList">
                                                <a-collapse style="background-color:#fcfcfc;" expandIconPosition="right" :accordion="true" 
                                                    :bordered="false">
                                                    <a-collapse-panel v-for="(item,index) in record.remarks" :key="index">
                                                        <template slot="header">
                                                            <div style="color:#14666f;font-size:0.85rem;">{{item.admin}}</div>
                                                        </template>
                                                        <p class="p1">{{ item.remark }}<span>{{ item.auditDate }}</span></p>
                                                    </a-collapse-panel>
                                                </a-collapse>
                                                <div v-if="record.remarks.length <= 0 && !record.aduit" style="text-align:center;padding:2rem 0;font-size:0.9rem;color:#ccc;">暫無備註信息</div>
                                            </div>
                                            <div v-if="record.aduit" class="tableBzViewTextarea" style="position:relative;">
												<viewfroms v-if='viewfromFn(record)' ref='viewfroms' @child='handclose()' :record='record'></viewfroms>
                                                <a-textarea :maxLength=200 :autoSize="{minRows: 4, maxRows: 10}" style="padding-bottom:2rem;" v-model="record.textareaValue" placeholder="請輸入備註信息"/>
                                                <span style="color:#bfbfbf;position:absolute;bottom:10px;right:10px;">{{record.textareaValue.length}}/200</span>
                                            </div>
                                            <div v-if="record.aduit && ifQt" class="tableBzViewBtnView">
                                               <a-popconfirm title="確認審批通過？" @visibleChange="visibleShow(record,'1')" v-model="popconfirm1Bol"  
                                                    ok-text="確定" cancel-text="取消"  @confirm="shTgEvent(record)" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
													    <a-icon slot="icon" type="question-circle-o" style="display: none;" />
                                                    <a-button @click="confirmCheck(record,'1')" class="tableBzViewBtn" style="background-color:#3bc7a1;">{{record.shKhadmin1Bol ? '已處理' :'審核通過'}}</a-button>
                                                </a-popconfirm>
												
                                                <a-popconfirm v-if="!record.shKhadmin1Bol" title="拒絕審批通過？" @visibleChange="visibleShow(record,'2')" v-model="popconfirm2Bol" 
                                                    ok-text="確定" cancel-text="取消"  @confirm="shUnTgEvent(record)" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
                                                    <a-icon slot="icon" type="question-circle-o" style="display: none;" />
													<a-button @click="confirmCheck(record,'2')" class="tableBzViewBtn" style="background-color:#ed4849;">審核拒絕</a-button>
                                                </a-popconfirm>
                                                <a-popconfirm v-if="!record.shKhadmin1Bol" title="確認取消開戶？" @visibleChange="visibleShow(record,'3')" v-model="popconfirm3Bol" 
                                                    ok-text="確定" cancel-text="取消"  @confirm="cancleEvent(record)" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
                                                    <a-icon slot="icon" type="question-circle-o" style="display: none;" />
													<a-button @click="confirmCheck(record,'3')" class="tableBzViewBtn" style="background-color:#ffa647;">取消開戶</a-button>
                                                </a-popconfirm>
                                            </div>
                                            <div v-if="record.aduit && !ifQt" class="tableBzViewBtnView">
                                                <a-popconfirm title="確認審批通過？" @visibleChange="visibleShow(record,'1')" v-model="popconfirm1Bol"  
                                                    ok-text="確定" cancel-text="取消"  @confirm="shTgEvent(record)" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
                                                    <a-icon slot="icon" type="question-circle-o" style="display: none;" />
													<a-button @click="confirmCheck(record,'1')" class="tableBzViewBtn" style="background-color:#3bc7a1;">{{record.shKhadmin1Bol ? '已處理' :'審核通過'}}</a-button>
                                                </a-popconfirm>
                                                <a-popconfirm v-if="!record.shKhadmin1Bol" title="拒絕審批通過？" @visibleChange="visibleShow(record,'2')" v-model="popconfirm2Bol" 
                                                    ok-text="確定" cancel-text="取消"  @confirm="shUnTgEvent(record)" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
                                                    <a-icon slot="icon" type="question-circle-o" style="display: none;" />
													<a-button @click="confirmCheck(record,'2')" class="tableBzViewBtn" style="background-color:#ed4849;">審核拒絕</a-button>
                                                </a-popconfirm>                                          
                                            </div>
                                        </div>
                                    </div>
                                </template> -->
								<!-- icon_bianji1:record.status == 2?require('../../image/gr_icon2.png'):icon_bianji -->
								<img :src="record.shShowBol ?  icon_gengduo1:record.status == 2?require('../../image/gr_icon3.png'): icon_gengduo"
								 class="imageC"
								@click='handshenhe(record)'>
                            <!-- </a-popover> -->
                        </div>
                        <div class="popoverView popoverView3" v-if='false'>
                            <a-popover :visible="record.moreShowBol" placement="leftTop" trigger="click"  :destroyTooltipOnHide="true"
                                :overlayStyle="{width:'calc(15rem)'}"  @visibleChange="moreEvent(record)" 
                                :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
                                <template slot="content">
                                    <div class="tableMoreView">
                                        <div class="moreViewTop">
                                            <a-popover v-if="ifZt||ifHt" v-model="record.moreFzShowBol" placement="left" trigger="click" 
                                                :overlayStyle="{width:'calc(20rem)'}" :destroyTooltipOnHide="true"
                                                :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
                                                <template slot="content">
                                                    <div class="tabelMoreFzView">
                                                        <div class="tabelMoreFzViewIn">
                                                            <div v-for="(item) in record.moreFzOption" :key="item.value" class="tabelMoreFzViewInList">
                                                                <div class="left">{{item.text}}：</div>
                                                                <div class="center">{{item.value}}</div>
                                                                <img src="../../image/icon_wenjian.png" @click="fzEvent(item.value)" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <img src="../../image/icon_wenjian.png">
                                            </a-popover> 
											<!-- 填土 -->
											  <a-popover v-model="visible_bold" trigger="click" placement="left">
											    <a slot="content">
													<viewfrom v-if='visible_bold' @child='handclose()' :record='record'></viewfrom>
												</a>
											   <img v-if='viewfromFn(record)' src="../../image/icon_bin.png"
											   style="cursor: pointer;width: 1.2rem;height: 1.2rem;margin-left: .5rem;margin-right: 1.5rem;">
											  </a-popover>
                                            <img src="../../image/icon_xiazai2.png" @click="downPic(record)">
                                            <!-- v-if="ifSQ && form.admintype=='khadmin4' && record.schedule == 3 && record.status == 0" -->
                                            <a-popover v-if="ifSQ && form.admintype=='khadmin4' && record.schedule == 3 && record.status == 0"   placement="left" trigger="click"  ref="popover4"
                                                :overlayStyle="{width:'calc(16rem)'}" :destroyTooltipOnHide="true"
                                                :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
                                                <template slot="content">
                                                    <div class="tabelMoreFzView">
                                                        <div class="tabelMoreFzViewIn2" style="text-align:center">
                                                            <span style="font-size:0.8rem;margin-right: 0.6rem;">{{substr(record.id,0,4)}}</span>
                                                             <a-input v-model="record.newcode" style="width:45%;font-size:0.8rem;margin-right: 0.6rem;" :max-length="3" @input="newcode(record)" placeholder="請輸入編號"/>
                                                            <a-popconfirm  title="是否確認修改開戶ID"   v-model="record.codeupdatflag" 
                                                                ok-text="確定" cancel-text="取消"  @confirm="newCodeSub(record)" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
                                                               <a-button  style="width:25%;background-color: rgb(59, 199, 161);color:#fff;font-size:0.8rem">提交</a-button>
                                                            </a-popconfirm>      
                                                        </div>
                                                    </div>
                                                </template>
                                                <img src="../../image/icon_updateid.png">
                                            </a-popover> 
                                        </div>
                                        <div class="moreViewBottom">
                                            <div class="moreCheckList" v-for="(item,index) in record.moreCheckOption" :key="item.label">
                                                <div>
                                                    <img :src="item.imgUrl">
                                                </div>
                                                <p @dblclick="imgShowEvent(record,item.yesImgUrl)">{{item.label}}</p>
                                                <a-checkbox :style="{marginLeft: 'auto'}" :checked="item.checked" @change="onChange(index,item.checked,record)"></a-checkbox>
                                            </div>
                                            <div class="imgShow" v-show="record.imgShowbol" @click="record.imgShowbol = false">
                                                <img :src="record.showImg">
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <img :src="record.moreShowBol ? icon_gengduo1:record.status == 2?require('../../image/gr_icon3.png'): icon_gengduo " class="imageC">
                            </a-popover> 
                        </div>
                    </div>
                </div>
            </a-table>
            <div class="paginationView">
                <div>第{{firstPage}}到{{secPage}}條，共{{total}}條記錄</div>
                <div style="margin-left:auto;">
                    <a-pagination v-model="pageNum" @change="pageChange" :total="total" :pageSize="perPage"/>
                </div>
                <div class="pageTzView">
                    <input type="text" v-model="tzPageNum" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')">
                    <span @click="tzEvent">跳轉</span>
                </div>
            </div>
        </div>
        <div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()">
            <div :class="pdf_cla_flag?'pdfviewIn':'pdfviewIn1'" >
                <div class="pdfTitle" v-if="pdfFlag">
                    <img v-if="ifQt" @click.stop="printEvent()" src="../../image/icon_dayin.png">
                    <img @click.stop="downLoad()" src="../../image/icon_xiazai1.png">
                </div>
                <!-- cspdf  不知道为啥之前用这个“cspdf” api， 替换的原因是掉第二遍不传参数 -->
                <iframe id="iframePdf" :src="$api.pdfs + pdfUrl" style="width: 100%; height: 100%" frameborder="0"></iframe>
                <iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
            </div>
        </div>
		<!-- <shenhe v-if='isshShowBol' :island='isshShowBol' @child='handclose' 
		:record='itemdata' :forms='form' :ifQt='ifQt'></shenhe> -->
		<handhome v-if='isshShowBol' :itemobj='itemdata' @child='handclose' :admintype="form.admintype" :applyid='{}'  :forms='form'></handhome>
        <handItem v-if="isopen" @child="yuyueclose"></handItem>
        <handItems v-if="isopens" @child="kaihuclose"></handItems>
        <!-- 搜索无结果弹窗 -->
        <div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
        <exportData  v-if="upFlag" @child="upclose" :item="form"></exportData>
    </div>
</template>
<script>

    import https from '@/plugins/http.js';
    import apiUrl from '@/assets/api.js';
	import shenhe from './shenhe.vue'
    import App from '@/assets/app.js';
    // import FileSave from 'file-save';
    import exportData from "./comhome/exportData";
    import handItem from "./comhome/handItem";
    import handItems from "./comhome/handItems";
    import icon_one from '../../image/sicon_one.png';
    import icon_one1 from '../../image/sicon_one1.png';
    import icon_two from '../../image/sicon_two.png';
    import icon_two1 from '../../image/sicon_two1.png';
    import icon_three from '../../image/sicon_three.png';
    import icon_three1 from '../../image/sicon_three1.png';
    import icon_four from '../../image/sicon_four.png';
    import icon_four1 from '../../image/sicon_four1.png';

    import icon_pdf from '../../image/icon_pdf.png';
    import icon_pdf1 from '../../image/icon_pdf1.png';
    import icon_bianji from '../../image/icon_beizhu.png';
    import icon_bianji1 from '../../image/icon_beizhu1.png';
    import icon_gengduo from '../../image/icon_gengduo.png';
    import icon_gengduo1 from '../../image/icon_gengduo1.png';

    import icon_renwu from '../../image/icon_renwu.png';
    import icon_renwu1 from '../../image/icon_renwu1.png';

    import wj_dlsfzOff from '../../image/wj_dlsfzOff.png';
    import wj_dz from '../../image/wj_dz.png';
    import wj_hkd from '../../image/wj_hkd.png';
    import wj_hksfzOff from '../../image/wj_hksfzOff.png';
    import wj_hz from '../../image/wj_hz.png';
    import wj_sfzOn from '../../image/wj_sfzOn.png';
    import wj_wgsfzOff from '../../image/wj_wgsfzOff.png';
    import wj_txz from '../../image/wj_txz.png';
    import { saveFileToLink,saveFileToBlob  } from 'web-downloadfile';
	import viewfrom from './formview.vue'
	import viewfroms from './formviews.vue'
	import handhome from './comhome/handhome.vue'
    import { Modal } from 'ant-design-vue';
    import { createVNode, defineComponent } from 'vue';
    import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
    export default {
		components:{
			viewfrom,viewfroms,shenhe,handhome,handItem,exportData,handItems
		},
        data() {
            return {
                httpFlag:window.location.protocol == 'https:',
                pdf_cla_flag:false,
                allurl1: '',
                upFlag:false,
                ishandout:false,
                isopen: false,
                isopens: false,
				isshShowBol:false,
				pdfFlag:false,
				itemdata:{},
                icon_one,icon_one1,icon_two,icon_two1,icon_three,icon_three1,icon_four,icon_four1,
                icon_pdf,icon_pdf1,icon_bianji,icon_bianji1,icon_gengduo,icon_gengduo1,
                icon_renwu,
                icon_renwu1,
				alarm_clock:require('@/image/alarm_clock.png'),
				formview:{
					
				},
                admintypeArr:[
                    {text:'客服審核',value:'khadmin1'},
                    {text:'中台審核',value:'khadmin2'},
                    {text:'後台審核',value:'khadmin3'},
                    {text:'授權審批',value:'khadmin4'},
                    // {text:'超級管理員',value:'khadmin'},
                ],
                khtypeArr:[
                    {text:'全部',value:9},
                    {text:'線上開戶',value:0},
                    {text:'預約開戶',value:1},
                    {text:'郵遞開戶',value:2},
                    // {text:'取消開戶',value:3},
                ],
                openAccountImport : this.$store.state.rolesdata.indexOf('openAccountImport') >= 0,
                ifZt : this.$store.state.rolesdata.indexOf('khadmin2') >= 0,
                ifQt : this.$store.state.rolesdata.indexOf('khadmin1') >= 0,
                ifHt : this.$store.state.rolesdata.indexOf('khadmin3') >= 0,
                ifSQ : this.$store.state.rolesdata.indexOf('khadmin4') >= 0,
                rolesIndx : this.$store.state.rolesdata.indexOf('khadmin1') >= 0 ? '1' : this.$store.state.rolesdata.indexOf('khadmin2') >= 0 ? '2' : this.$store.state.rolesdata.indexOf('khadmin3') >= 0 ? '3' :this.$store.state.rolesdata.indexOf('khadmin4') >= 0 ? '4' : '' ,
                form:{
                    admintype: this.adminFn(),
                    khtype:9,
                    searchstr:'',
                    timeDate:[]
                },
                pageNum:1,
                perPage:10,
                total:1,
                tzPageNum:'',
                columns:[
					//開戶ID->證券編號    推薦ID->邀請編號
					 // { title: 'D', dataIndex: 'key' },
                    {title: '證券編號',dataIndex: '',align:'center',width:'10%',scopedSlots: { customRender: 'id' }},//開戶ID
					// {title: '推薦ID',dataIndex: 'inviter',align:'center',width:'8%'},
                    {title: '提交時間',dataIndex: 'submitdate',align:'center',width:'15%'},
                    {title: '操作人員',dataIndex: 'adminname',align:'center',width:'10%'},
                    {title: '開戶方式',dataIndex: '',align:'center',width:'15%',scopedSlots: { customRender: 'khtype' }},
                    {title: '開戶進度',dataIndex: '',align:'center',width:'26%',scopedSlots: { customRender: 'schedule' }},
                    {title: '審批時間',dataIndex: 'auditdate',align:'center',width:'17%'},
                    {title: '操作',dataIndex: '',align:'center',width:'auto',scopedSlots: { customRender: 'toolArr' }},
                ],
                columnsData:[],
				visible_bold:false,
                // 備註彈出
                popconfirm1Bol:false,
                popconfirm2Bol:false,
                popconfirm3Bol:false,
                ifClickBtn:false,
                // pdf彈出
                pdfShow : false,
                pdfUrl : '',
                pdfBolUrl : '',
                blob:'',
                // 任務數
                missionnum:0,
                missionflag:false,
                // 證件圖標 arr
                wjMessArr : [
                    {label:"香港通行證正面",value:"HK_TW_MacaoPassimage",checked:true,imgUrl:wj_txz},
                    {label:"香港通行證背面",value:"HK_TW_MacaoPassimage2",checked:true,imgUrl:wj_txz},
                    {label:"大陸居民身份證正面",value:"identificationimage",checked:true,imgUrl:wj_sfzOn},
                    {label:"大陸居民身份證背面",value:"identificationimage2",checked:true,imgUrl:wj_dlsfzOff},
                    {label:"護照",value:"passportimage",checked:true,imgUrl:wj_hz},
                    {label:"外國居民身份證正面",value:"identificationimage_foreign",checked:true,imgUrl:wj_sfzOn},
                    {label:"外國居民身份證背面",value:"identificationimage_foreign2",checked:true,imgUrl:wj_wgsfzOff},
                    {label:"香港居民身份證正面",value:"identificationimage_HK",checked:true,imgUrl:wj_sfzOn},
                    {label:"香港居民身份證背面",value:"identificationimage_HK2",checked:true,imgUrl:wj_hksfzOff},
                    {label:"地址證明文件",value:"addressimage",checked:true,imgUrl:wj_dz},
                    {label:"匯款單",value:"transferAccountsimage",checked:true,imgUrl:wj_hkd},
                ],
                selectedRows:[],
                submitusers:[],
                useMessList:''
				
            }
        },
        created(){
            let _this = this;
            _this.messLoad();
        },
        computed: {
            firstPage: function () {
                let _this = this;
                let a = (_this.pageNum-1)*10;
                let b = 1;
                return _this.total > 0 ? Number(a) + Number(b) : 0
            },
            secPage : function(){
                let _this = this;
                let a = _this.pageNum*10;
                let b = a > _this.total ? _this.total : a;
                return b
            },
        },
		mounted() {
            let aaa=[
                {a:1},
                {b:1},
                {c:1},
            ]
            aaa.map((ev, ind) => {
                console.log(ev,ind);

            })
        },
		methods: {
            //导入按钮方法
            beforeUpload(file) {
                var fileFormat = file.name
                    .substring(file.name.lastIndexOf("."))
                    .toLowerCase();
                const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
                if (!isJpgOrPng) {
                    this.$message.error('只能上傳xls或xlsx文件!');
                }
                return isJpgOrPng;
            },
            //导入按钮
            handleChange(info) {
                if (info.file.response) {
                    if (info.file.response.qmiscode == 1000) {
                        this.loading = true;
                        this.$message.success('導入成功');
                        this.messLoad();
                    } else {
                        this.loading = false;
                        this.$message.error(info.file.response.qmismsg);
                    }
                }
              
            },
            upClick(){
                this.upFlag = true
            },
            // 查看选中的多选框
            onSelectChange(selectedRowKeys, selectedRows) {
                this.selectedRows = selectedRowKeys;
                console.log(this.selectedRows,'复选框查看',selectedRows);
                this.submitusers = []
                for (let i = 0; i < selectedRows.length; i++) {
                    let arr = {
                        id:selectedRows[i].pdfcode,
                        khtype:selectedRows[i].khtype,
                        delete_flag:selectedRows[i].delete_flag,

                    }
                    this.submitusers.push(arr)
                }
            },
            // 删除记录
            delClick(){
                if(this.submitusers.length>0){
                    this.$confirm("是否刪除此數據，刪除後不可恢復", "是否刪除？", {
                        confirmButtonText: "確認",
                        cancelButtonText: "取消",
                        confirmButtonClass: "confirmbtn",//自定义class
                        type: "warning"
                    }).then(() => {
                        // confirmButton回调
                        this.$ajax({
                            method: "post",
                            // url: 'http://202.130.113.149:3785/admin/clearUserKhMsg',
                            url: this.$api.clearUserKhMsg,
                            data: {
                            submitusers:this.submitusers
                            },
                        }).then((res) => {
                            if (res.data.qmiscode == 1000) {
                                this.$message.success('刪除成功')
                                this.messLoad();
                                // this.$router.go(0)
                            } else {
                                App.oTool.warningT(res.data.qmismsg);
                            }
                        });
                        next()
                    }).catch(() => {
                    })
                }
            },
            
			rowstely(record, index) {
				if (record.status == 2  || record.status == 3) {
					return {
						style: {
							'color': '#999',
							'opacity': '0.5'
						},
					}
				}
			},
            
			adminFn(){
				if(this.$store.state.rolesdata.indexOf('khadmin2')>=0){
					return 'khadmin2'
				}else if(this.$store.state.rolesdata.indexOf('khadmin3')>=0){
					return 'khadmin3'
				}else if(this.$store.state.rolesdata.indexOf('khadmin4')>=0){
					return 'khadmin4'
				}else{
					return 'khadmin1'
				}
			},
			viewfromFn(record){
				let state = false
				this.$store.state.roles.map(ev=>{
					if(ev.role == "khadmin1"){
						state = true
					}
				})
			 return record.finishflag == 1&&this.form.admintype == "khadmin1"&&state
			},
			handclose(val){
				this.columnsData.map((ele,index) => {
					ele.shShowBol = false;
				})
				this.isshShowBol = false
				this.visible_bold = false
				if(val){
					this.messLoad();
				}
                // this.$router.go(0)
			},

            handleClear(val){
                if (!this.form.searchstr) {
                    this.messLoad()
                }
            },
            
            handleCancel(ev){
                this.ishandout = false
			},
            // 获取页面数据
            messLoad(){
                this.selectedRows = [];
                let _this = this;
                let json = {
                    token : _this.$store.state.token,
                }
                https.fetchPost(apiUrl.getAuditList,Object.assign({
                    admintype:_this.form.admintype,
                    khtype:_this.form.khtype == 9 ? null : _this.form.khtype,
                    searchstr:_this.form.searchstr,
                    timebegin:_this.form.timeDate[0] ? App.oDate.secsTime3(_this.form.timeDate[0]._d) : null,
                    timeend:_this.form.timeDate[1] ? App.oDate.secsTime3(_this.form.timeDate[1]._d) : null
                },{
                    missionflag: _this.missionflag ? '1' : '0',
                    pageNum : _this.pageNum,
                    perPage : _this.perPage
                }),json).then((data) => {
                    if(Object.is(data.qmiscode,1000)){
                        data.auditList.forEach((ele,index) => {
                            // 審核彈出用
                            ele.shShowBol = false;
                            ele.key = index;
                            ele.remarks = [];
                            ele.textareaValue = '';
                            ele.aduit = false;
                            ele.state = 0;
                            ele.ishanding = false;
                            // 前台（客服）審核任務中數據 按鈕 判斷
                            ele.shKhadmin1Bol = false;
                            // pdf彈出用
                            ele.pdfShowBol = false;
                            // 更多彈出用
                            ele.moreShowBol = false;
                            ele.moreFzShowBol = false;
                            ele.moreCheckOption = [];
                            ele.moreFzOption = [];
                            ele.imgShowbol = false;
                            ele.showImg = '';
                        });
                        _this.missionnum = data.missionnum;
                        _this.total = data.total;
                        _this.tzPageNum = '';
                        _this.columnsData = data.auditList;
                        if (_this.form.searchstr || _this.form.timeDate[0].length>0) {
                            if (_this.columnsData.length<=0) {
                                _this.ishandout = true
                            }
                        }
                    }else{
                        App.oTool.warningT(data.qmismsg);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            searchEvent(){
                this.pageNum = 1;
                this.missionflag = false;
                this.messLoad();
            },
            newcode(record){
                record.newcode = record.newcode.replace(/[^0-9]+/g, "");
            },
            clearEvent(){
                this.form = {
                    admintype:this.adminFn(),
                    khtype:9,
                    searchstr:'',
                    timeDate:[]
                }
                this.messLoad();
            },
            messionEvent(){
                this.pageNum = 1;
                this.missionflag = !this.missionflag;
                this.messLoad();
            },
            admintypeChange(){
                this.pageNum = 1;
                this.messLoad();
            },
            // 打开弹窗
			handshenhe(record){//
			this.shEvent(record)
				if(record.schedule < this.rolesIndx && this.rolesIndx < '4'){
				    App.oTool.warningT('請先審核PDF');
				    // this.popconfirm1Bol = false;
				    // this.popconfirm2Bol = false;
				    // this.popconfirm3Bol = false;
				    return
				}
				// if(record.schedule == 4 && record.status == 0 && !record.aduit){
				//     App.oTool.warningT("開戶審核已完成");
				//     return;
				// }
				// if(record.status == 2){
				//     App.oTool.warningT("開戶審核已取消");
				//     return;
				// }
				// if(record.websiteflag != 0 && record.finishflag ==1 &&_this.forms.admintype =='khadmin1'){
				//     App.oTool.warningT("沒有可用操作");
				//     return;
				// }
				// if(this.ifClickBtn){
					record.shShowBol = true;
					this.isshShowBol = true;
					// moreShowBol
					this.itemdata = record;
				// }
			},
            substr(str,a,b){
                return str.toString().substring(a,b)
            },
            // 分页跳转
            tzEvent(){
                let _this = this;
                let maxPageNum = Math.ceil(_this.total/_this.perPage);
                if(_this.tzPageNum <= maxPageNum){
                    _this.pageNum = Number(_this.tzPageNum);
                    _this.messLoad();
                }else{
                    App.oTool.warningT('請輸入有效的頁碼');
                }
            },
            pageChange(page, pageSize){
                this.pageNum = page;
                this.messLoad();
            },
            // 获取弹窗数据
            shEvent(record){
                let _this = this;
                if(!record.shShowBol){
                    let json = {
                        token : _this.$store.state.token,
                    }
                    https.fetchPost(apiUrl.getAdminRemarks,{
                        admintype:_this.form.admintype,
                        token:json.token,
                        id:record.pdfcode
                    },json).then((data) => {
                        if(Object.is(data.qmiscode,1000)){
                            record.remarks = data.remarks;
                            record.aduit = data.aduit;
                            record.state = data.state;
                            record.ishanding = data.ishanding == '1' ? true : false;
                            record.shShowBol = true;
                            record.shKhadmin1Bol = (record.ishanding && _this.form.admintype == 'khadmin1') && !(record.schedule == 1 && record.status == 1);
							// console.log(record.shKhadmin1Bol)
                        }else{
                            App.oTool.warningT(data.qmismsg);
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                }else{
                    record.shShowBol = false;
                }
            },
            confirmCheck(){
                let _this = this;
                _this.ifClickBtn = true;
            },
            newCodeSub(record){
                // let _this = this;
                record.codeupdatflag = false;
                if(!record.newcode || isNaN(record.newcode) || Object.keys(record.newcode).length != 3){
                    App.oTool.warningT("請輸入有效編號");
                    return;
                }
                let _this = this;
                let json = {
                    token : _this.$store.state.token,
                }
                https.fetchPost(apiUrl.updateNewCode,{
                    token:json.token,
                    pdfcode:record.pdfcode,
                    newcode:_this.substr(record.id,0,4)+record.newcode
                },json).then((data) => {
                    if(Object.is(data.qmiscode,1000)){
                        _this.messLoad();
                        App.oTool.successT('操作成功');
                    }else{
                        App.oTool.warningT(data.qmismsg);
                    }
                }).catch(err => {
                    console.log(err);
                });

            },
            visibleShow(record,type){
                let _this = this;
                if(record.schedule < _this.rolesIndx && _this.rolesIndx < '4'){
                    App.oTool.warningT('請先審核PDF');
                    _this.popconfirm1Bol = false;
                    _this.popconfirm2Bol = false;
                    _this.popconfirm3Bol = false;
                    return
                }
                if(_this.ifClickBtn){
                    if(Object.is(type,'1')){
                        // if(!record.textareaValue.trim()){
                        //     _this.popconfirm2Bol = false;
                        //     App.oTool.warningT('請填寫備註信息');
                        // }else{
                            _this.popconfirm1Bol = true;
                        // }
                    }else if(Object.is(type,'2')){
                        if(!record.textareaValue.trim()){
                            _this.popconfirm2Bol = false;
                            App.oTool.warningT('請填寫備註信息');
                        }else{
                            _this.popconfirm2Bol = true;
                        }
                    }else if(Object.is(type,'3')){
                        if(!record.textareaValue.trim()){
                            _this.popconfirm3Bol = false;
                            App.oTool.warningT('請填寫備註信息');
                        }else{
                            _this.popconfirm3Bol = true;
                        }
                    }
                    _this.ifClickBtn = false;
                }
            },
            shTgEvent(record){
				
				let viewfroms = ''
				if(this.viewfromFn(record)){
					viewfroms = this.$refs['viewfroms'].imfrom()
					if(!viewfroms){
						return //不通过
					}
				}
                let _this = this;
                let json = {
                    token : _this.$store.state.token,
                }
                if(!record.textareaValue.trim()){
                    record.textareaValue = '審核通過';
                }
			
                https.fetchPost(apiUrl.KhAdminAduit,{
                    admintype:_this.form.admintype,
                    token:json.token,
                    id:record.pdfcode,
                    khid:record.id,
                    status:'0',
					viewfroms:viewfroms,
                    remark:record.textareaValue
                },json).then((data) => {
                    if(Object.is(data.qmiscode,1000)){
                        _this.messLoad();
                        App.oTool.successT('操作成功');
                    }else{
                        App.oTool.warningT(data.qmismsg);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            shUnTgEvent(record){
                let _this = this;
                let json = {
                    token : _this.$store.state.token,
                }
                https.fetchPost(apiUrl.KhAdminAduit,{
                    admintype:_this.form.admintype,
                    token:json.token,
                    id:record.pdfcode,
                    khid:record.id,
                    status:'1',
                    remark:record.textareaValue
                },json).then((data) => {
                    if(Object.is(data.qmiscode,1000)){
                        _this.messLoad();
                        App.oTool.successT('操作成功');
                    }else{
                        App.oTool.warningT(data.qmismsg);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            cancleEvent(record){
                let _this = this;
                let json = {
                    token : _this.$store.state.token,
                }
                https.fetchPost(apiUrl.KhAdminAduit,{
                    admintype:_this.form.admintype,
                    token:json.token,
                    id:record.pdfcode,
                    khid:record.id,
                    status:'2',
                    remark:record.textareaValue
                },json).then((data) => {
                    if(Object.is(data.qmiscode,1000)){
                        _this.messLoad();
                        App.oTool.successT('操作成功');
                    }else{
                        App.oTool.warningT(data.qmismsg);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            pdfEvent(record){
                this.pdf_cla_flag = true
                this.pdfFlag = false;
                let _this = this;
                if(record.schedule == 4 && record.status == 0 && !record.aduit){
                    App.oTool.warningT("開戶審核已完成");
                    return;
                }
                if(record.status == 3){
                    App.oTool.warningT("開戶審核已完成");
                    return;
                }
                if(record.status == 2){
                    App.oTool.warningT("開戶審核已取消");
                    return;
                }
				
                _this.pdfUrl = _this.$api.getKHPdfData + record.pdfcode ;
			    _this.pdfUrl = this.$api.url +'admin/getKHPdfData?id=' +  record.pdfcode ;
				if(record.reading == 0){
					 _this.pdfUrl += '&m='  + Date.parse(new Date())
				}
                https.fetchGetPdf('admin/getKHPdfData?id=' + record.pdfcode).then((data) => {
                    this.pdfFlag = true;
                    let blob = new Blob([data], { type: 'application/pdf' });
                    _this.blob = blob;
                    console.log(_this.blob);
                    let b = window.URL.createObjectURL(blob); 
                    _this.pdfBolUrl = b;
                }).catch(err => {
                    console.log(err);
                });
				
                setTimeout(()=>{
                    _this.pdfShow = true;
                    record.pdfShowBol = true;
                },500);
            },
            pdfEvent1(pxfs){
                this.pdfFlag = false;
                let str = this.$api.cspdf; //getUnsk
                let url = ''
                let _this = this;
                let begin = _this.form.timeDate[0] ? App.oDate.secsTime3(_this.form.timeDate[0]._d) : ''
                let end =  _this.form.timeDate[1] ? App.oDate.secsTime3(_this.form.timeDate[1]._d) : ''
                let khtype =  _this.form.khtype == 9 ? '' : _this.form.khtype
                let sort =  pxfs == undefined ? '' : pxfs
                url = _this.$api.downLoadOpenAccountPDF;
                url += '?token=' + _this.$store.state.token
                url += '&admintype=' + _this.form.admintype
                url += '&khtype=' + khtype
                url += '&searchstr=' + _this.form.searchstr
                url += '&timebegin='+ begin
                url += '&timeend=' + end
                url += '&sort=' + sort
                url += '&m=' + Date.parse(new Date())
                _this.allurl1 = str + url
                _this.pdfUrl = url
                https.fetchGetPdf( _this.pdfUrl).then((data) => {
                    _this.pdfFlag = true;
                    let blob = new Blob([data], { type: 'application/pdf' });
                    _this.blob = blob;
                    console.log(_this.blob);
                    let b = window.URL.createObjectURL(blob); 
                    _this.pdfBolUrl = b;
                }).catch(err => {
                    console.log(err);
                });
				
                setTimeout(()=>{
                    _this.pdfShow = true;
                },500);
            },
            pdfShowUNEvent(){
                let _this = this;
                _this.pdfShow = false;
                _this.columnsData.forEach((ele)=>{
                    ele.pdfShowBol = false;
                })
                _this.messLoad();
            },
            downLoad(){
                let _this = this;
                // saveFileToLink(_this.pdfUrl,'帳戶申請書','pdf');
                if (this.pdf_cla_flag) {
                    saveFileToBlob(_this.blob,'帳戶申請書','pdf');
                }else{
                    const date = new Date();
                    const year = date.getFullYear();
                    let month = date.getMonth() + 1;
                    if (month < 10) {
                        month = `0${month}`;
                    }
                    let day = date.getDate();
                    if (day < 10) {
                        day = `0${day}`;
                    }
                    var currentDate = `${year}${month}${day}`;
                    saveFileToBlob(_this.blob,currentDate+' 開戶信息','pdf');
                }
            },
            printEvent(){
                let _this = this;
                const printIframe = document.getElementById("toPrintIframe");
                let frameWindow = printIframe.contentWindow;
                frameWindow.print();
                setTimeout(()=>{
                    window.URL.revokeObjectURL(_this.blob);
                },500)
            },
            moreEvent(record){
                let _this = this;
                if(record.schedule == 4 && record.status == 0 && !record.aduit){
                    App.oTool.warningT("開戶審核已完成");
                    return;
                }
                if(record.status == 2){
                    App.oTool.warningT("開戶審核已取消");
                    return;
                }
				if(record.websiteflag != 0 && record.finishflag ==1 &&_this.form.admintype =='khadmin1'){
				    App.oTool.warningT("沒有可用操作");
				    return;
				}
				
                if(!record.moreShowBol){
                    let json = {
                        token : _this.$store.state.token,
                    }
                    https.fetchPost(apiUrl.getOpeningList,{
                        id:record.pdfcode
                    },json).then((data) => {
                        if(Object.is(data.qmiscode,1000)){
                            let arr = [];
                            let useMess = data.picList;
                            this.useMessList = data.picList;
                            useMess.forEach((ele)=>{
                                for(var a in ele){
                                    ele.indexStr = a;
                                    ele.url = ele[a];
                                } 
                                _this.wjMessArr.forEach((eld)=>{
                                    if(eld.value == ele.indexStr){
                                        eld.yesImgUrl = ele.url;
                                        arr.push(eld);
                                    }
                                });
                            });
                            record.moreFzOption = [
                                {text:'中文名稱',value:data.cn_name},
                                {text:'英文名稱',value:data.en_name},
                                {text:'電話號碼',value:data.phonenum},
								{text:'電郵地址',value:data.email},
                                {text:'身份信息',value:data.id_number},
                                {text:'地址信息',value:data.address},
                            ];
                            record.moreCheckOption = arr;
                            record.moreShowBol = true;
                        }else{
                            App.oTool.warningT(data.qmismsg);
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                }else{
					//二级弹窗
					_this.visible_bold = false;
					//关闭一级弹窗
                    record.moreShowBol = false;
                }
            },
            onChange(index,bol,record){
                record.moreCheckOption[index].checked = !bol;
            },
            downPic(record){
                let useMess = record.moreCheckOption;
                useMess.forEach((ele)=>{
                    if(ele.checked){
                        saveFileToLink(ele.yesImgUrl,ele.label,'png');
                    }
                });
            },
            fzEvent(value){
                let clipboard = new this.$clipboard('img', {
                    text: function () {
                        return value
                    }
                })
                clipboard.on('success', e => {
                    App.oTool.successT('複製成功');
                    clipboard.destroy(e)
                })
                clipboard.on('error', e => {
                    App.oTool.warningT('複製失敗');
                    clipboard.destroy(e)
                })
            },
            imgShowEvent(record,imgUrl){
                record.imgShowbol = true;
                record.showImg = imgUrl;
            },

            // 预约开户
            kaihuClick(){
                this.isopen = true;
            },
            yuyueclose(val) {
                this.isopen = false;
                this.messLoad();
                // this.$router.go(0)
                console.log(val);
            },
            kaihuclose(val) {
                this.isopens = false;
                this.messLoad();
                // this.$router.go(0)
                console.log(val);
            },
            queryData(val){
                // this.$ajax({
                //     method: 'get',
                //     url: this.$api.downLoadOpenAccountExcel,
                //     headers: {
                //     token: this.$store.state.token
                //     },
                //     data: {
                //         sort:val
                //     }
                // }).then(res => {
                    
                // })

                let url = ''
                let _this = this;
                let begin = _this.form.timeDate[0] ? App.oDate.secsTime3(_this.form.timeDate[0]._d) : ""
                let end =  _this.form.timeDate[1] ? App.oDate.secsTime3(_this.form.timeDate[1]._d) : ""
                let khtype =  _this.form.khtype == 9 ? "" : _this.form.khtype
                let sort =  val == undefined ? "" : val
                url = _this.$api.downLoadOpenAccountExcel;
                url += '?token=' + _this.$store.state.token
                url += '&admintype=' + _this.form.admintype
                url += '&khtype=' + khtype
                url += '&searchstr=' + _this.form.searchstr
                url += '&timebegin='+ begin
                url += '&timeend=' + end
                url += '&sort=' + sort
                url += '&headRows=1'
                console.log(url);
                window.location.href = url;
             
            },
            upclose(val){
                this.upFlag = false;
                if (val.xzgs == 'PDF') {
                    this.pdf_cla_flag = false
                    this.pdfEvent1(val.pxfs)
                }
                if (val.xzgs == 'Excel') {
                    this.queryData(val.pxfs)
                }
            }
        },
    };

</script>


